<template>
  <router-view />
</template>

<script>
export default {
  name: 'units-pages-container',
};
</script>
